import * as React from 'react';
import { useState } from "react";
import { useParams } from 'react-router-dom';
import { login } from '../../../api/authClientApi';
import { LoginPageView } from '../../_layouts/LoginPageView';

import { forgiveWhitespaceAndCase } from '../../../amorg-common';
import { PublicPageWrapper } from '../../_pageWrappers/PublicPageWrapper';

export default function LoginPage(): JSX.Element {

    const params = useParams<{siteId:string}>();

    return (
        <PublicPageWrapper hideTop siteId={params.siteId}>
            <Login />
        </PublicPageWrapper>
    );
}


function Login():JSX.Element
{

    const [errorMessage, setErrorMessage] = useState<string>('');
    const [siteIdFromUrl, setSiteIdFromUrl] = useState('');
    const [siteId, setSiteId] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const params = useParams<{siteId:string}>();

    React.useEffect(()=>{
        setSiteIdFromUrl(params.siteId || '');
    },[params.siteId])
    

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        // ?fname=johnny&lname=depp
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        const returnUrl = urlParams.get('return');

        setErrorMessage('');
        
        const usedSiteId = siteIdFromUrl || siteId;

        const groomedSiteId = forgiveWhitespaceAndCase(usedSiteId);
        const groomedEmail = forgiveWhitespaceAndCase(email);

        const loginResult = await login(groomedSiteId, groomedEmail, password);
        if (loginResult.isSuccess) {
            if (returnUrl)
            {
                document.location.assign(returnUrl);
            }
            else
            {
                document.location.assign('/');
            }
        }
        else
            setErrorMessage('Ugyldigt login - tjek dine oplysninger og prøv igen');
    }

    function handleSiteIdChange(value:string)
    {
        setSiteId(value);
    }

    function handleEmailChange(value:string)
    {
        setEmail(value);
    }

    function handlePasswordChange(value:string)
    {
        setPassword(value);
    }


    return (
        <LoginPageView
            cardHeader="AMORG"
            onSubmit={handleSubmit}
            email={email}
            onEmailChange={handleEmailChange}
            password={password}
            onPasswordChange={handlePasswordChange}
            organisation={!siteIdFromUrl ? siteId : undefined}
            onOrganisationChange={!siteIdFromUrl ? handleSiteIdChange : undefined}
            forgotPasswordHref="/request/resetpassword"
            errorMessage={errorMessage}
        />
    );
}